import PipelinePickupDetailPage from "components/Logistics/Pickups/Details/PipelinePickupDetailPage";
import { Route, Routes } from "react-router-dom";
import NewLogisticsPickups from "components/Logistics/Pickups/NewLogisticsPickups";

export default function LogisticsPlatformPage() {
  return (
    <Routes>
      <Route index element={<NewLogisticsPickups />} />
      <Route path="/pickups/:pickupUuid" element={<PipelinePickupDetailPage />} />
    </Routes>
  );
}
